import { render, staticRenderFns } from "./aufgaben_fertig.vue?vue&type=template&id=01edaf7a&scoped=true"
import script from "./aufgaben_fertig.vue?vue&type=script&lang=js"
export * from "./aufgaben_fertig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01edaf7a",
  null
  
)

export default component.exports